
import { defineComponent, ref, onMounted, computed } from "vue";
//import LightDarkSwtichBtn from "./LightDarkSwtichBtn.vue";
import stateStore from "../../utils/store";
import store from "@/store";
export default defineComponent({
  name: "MainHeader",
  /*components: {
    LightDarkSwtichBtn,
  },*/
  setup() {
    const curUserPayload = computed(() => store.getters[`auth/curUserObject`]);

    const stateStoreInstance = stateStore;
    const isSticky = ref(false);

    onMounted(() => {
      window.addEventListener("scroll", () => {
        let scrollPos = window.scrollY;
        isSticky.value = scrollPos >= 100;
      });
    });

    return {
      curUserPayload,
      isSticky,
      stateStoreInstance,
    };
  },
  methods: {
    logout() {
      store.dispatch("auth/logout");
    },
  },
});
